var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "search-filter__icon-close",
      attrs: {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L18 16.5858L34.2929 0.292893C34.6834 -0.0976311 35.3166 -0.0976311 35.7071 0.292893C36.0976 0.683417 36.0976 1.31658 35.7071 1.70711L19.4142 18L35.7071 34.2929C36.0976 34.6834 36.0976 35.3166 35.7071 35.7071C35.3166 36.0976 34.6834 36.0976 34.2929 35.7071L18 19.4142L1.70711 35.7071C1.31658 36.0976 0.683417 36.0976 0.292893 35.7071C-0.0976311 35.3166 -0.0976311 34.6834 0.292893 34.2929L16.5858 18L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }